export const NEW_INTERFACE_BANNER = 'new-interface-banner'
